export default {
	data() {
		return {
			tutorialType: 'deposits'
		}
	}
}
